module.exports = __webpack_public_path__ + "img/night-bg-sm.83aa684b.png";